export const digit = (input, minimumIntegerDigits) => {
  return input.toLocaleString('ko-KR', { minimumIntegerDigits });
};
